import { LOCATION_CHANGE } from 'connected-react-router';
import { take, put, call, fork, cancel, cancelled, takeEvery, delay } from 'redux-saga/effects';

import {
  START_RENDER_STATUS_POLLING,
  STOP_RENDER_STATUS_POLLING,
  fetchRenderStatusFailed,
  stopRenderStatusPolling,
  pollingCancelled,
  renderFailed,
  RENDER_FAILED,
  fetchRenderProgressSuccess,
  GET_VIDEO_DOWNLOAD_URL_FAILED,
  DOWNLOAD_REQUEST_FAILED
} from '../actionCreators/downloadActions';
import { appServices } from '../shared/helpers/app-services/AppServices';
import { sendErrorToSentry } from '../logging';

const polls = [];
const progressPolls = [];

function* pollProgressApi(shortId, format) {
  while (true) {
    try {
      yield delay(5000);
      const result = yield call(appServices.fetchRenderProgress, shortId);
      if (result.mergeComplete) {
        yield put(stopRenderStatusPolling(shortId, format));
      }
      if (result.errors?.length > 0) {
        yield put(renderFailed({ message: 'render failed' }));
      }
      yield put(fetchRenderProgressSuccess(shortId, result));
    } catch (e) {
      sendErrorToSentry(e);
      yield put(fetchRenderStatusFailed(e, shortId));
    } finally {
      if (yield cancelled()) {
        yield put(pollingCancelled(shortId));
        return;
      }
    }
  }
}

function* pollDownloadSaga() {
  let action;
  while ((action = yield take(START_RENDER_STATUS_POLLING))) {
    progressPolls.push({
      shortId: action.shortId,
      pollApiTask: yield fork(pollProgressApi, action.shortId, action.format)
    });

    yield takeEvery(STOP_RENDER_STATUS_POLLING, cancelPolling);
    yield takeEvery(
      [LOCATION_CHANGE, GET_VIDEO_DOWNLOAD_URL_FAILED, DOWNLOAD_REQUEST_FAILED, RENDER_FAILED],
      cancelAllPolling
    );
  }
}

function* cancelPolling(action) {
  const pollToCancel = polls.find(poll => poll.shortId === action.shortId);
  const progressPollToCancel = progressPolls.find(poll => poll.shortId === action.shortId);
  if (pollToCancel) {
    yield cancel(pollToCancel.pollApiTask);
    polls.pop(pollToCancel);
  }
  if (progressPollToCancel) {
    yield cancel(progressPollToCancel.pollApiTask);
    progressPolls.pop();
  }
}

function* cancelAllPolling() {
  yield cancel([...polls, ...progressPolls].map(p => p.pollApiTask));
}

export default pollDownloadSaga;
